/**
 * 利用者が打ち込み、ほかの人にも見せる文字列の共通の規則（ニックネーム #169、必殺技の名前 #204、選手の名前 #271）。
 */
/**
 * 見せられない文字。改行・制御文字（`Cc`）・行と段落の区切り（`Zl` / `Zp`）・文字の向きを変える制御文字。
 *
 * **ゼロ幅接合子（U+200D）は通す。** 家族などの絵文字の組み合わせに使われている。
 * 向きの制御文字は、表示を並べ替えて別の名前に見せられるので通さない。
 */
export const UNPRINTABLE = /[\p{Cc}\p{Zl}\p{Zp}\u202A-\u202E\u2066-\u2069]/u;
